// import React from "react";

interface InputProps {
  type?: "text" | "password"; // Add 'type' to support input types like 'text', 'password', etc.
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const Input: React.FC<InputProps> = ({
  type = "text", // Default type to 'text' if none is provided
  placeholder,
  name,
  value,
  onChange,
  className = "",
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      className={`w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary ${className}`}
    />
  );
};

export default Input;
